module.exports = __webpack_public_path__ + "static/media/12UNCTAD8.1f7eb370.jpg";